import React , {Component} from 'react'
import {Link} from 'react-router-dom'
import $ from 'jquery';
import unSave from '../../../assets/icons/save.png'
import Save from '../../../assets/icons/unsave.png'
import './friends.css'
window.$ = $;

export default class Card extends Component{
    constructor(props){
        super(props);
        this.state = {
            data: [],
            expanded: false,
           showTitles: false,
           saveCount: props.saveCount
       };
    }
    toggle = () => {
        this.setState({expanded: !this.state.expanded , saveCount: this.state.saveCount + 1})

    };
    toggleSaveCounter = () => {
        this.setState({expanded: !this.state.expanded , saveCount: this.state.saveCount - 1})
    };


    componentDidMount() {
        
      }
       data =  { "pageNumber": 1,
       "pageSize": 24,
       "filter":
      { "Color": [], 
        "Brand": [], 
         "FabricType": [], 
          "Design": [], 
          "DupattaType": [],
          "DressType": [],
          "Price": []
         
      } };
       
      
    
    render(){ 
        return(
        
           <li className="friend-item">
           <Link className="url" href="/">
          <div className="FName">
          <Link to="limeLight" className="brandName" style={{color: "#365899"}}>{this.props.title}</Link>
          </div>
          <div className="FS-image">
          <img className="Fimage" src={this.props.image}></img>

          <div class="info">
          <strong>{this.props.brandName}</strong> 
          </div>

          <span class="sprice-tag"  style={{display: `${this.props.sale ? "": 'none'}`}}>50% Off</span>
          </div>
          <div className="F-item-detail">
          <h4 className="Fprice"><span className="currency">Rs</span>{this.props.price}</h4>
         
          <span className="FWraper" onClick={this.toggleSaveCounter} style={{display: `${this.state.expanded ? "": 'none'}`}}>
          <img className="FsaveProduct" src={Save}  />
          </span>
         <span className="FWraper" onClick={this.toggle} style={{display: `${this.state.expanded ? "none": ''}`}}>
         <img className="FsaveProduct" src={unSave}/>
         </span>
         <span className="totalSave"><span>(<span>{this.state.saveCount}</span>)</span></span>
          </div>
        </Link>
        </li>
        )}}